import React, { Component } from 'react'
import { connect } from "react-redux";
import { fetchUser } from "../../store/users/operations";
import { getUserWithId, isUpdatingUser } from "../../store/users/selectors";

class UserDecorator extends Component {
    componentDidMount(){
        this.props.fetchUser(this.props.userId);         
    }

    render() {
        let children = undefined;
        if(this.props.user_profile){
            children = React.Children.map(this.props.children, (child, index) => {
                return React.cloneElement(child, {user: this.props.user_profile});
            });
        }
        return (
            <>
            {
                !this.props.isLoading && this.props.user_profile &&
                children            
            }
            </>
        )
    }
}

const mapStateToProps = (state, own_props) => ({
    user_profile: getUserWithId(state, own_props.userId),
    isLoading: isUpdatingUser(state, own_props.userId)
});

const mapDispatchToProps = dispatch => ({   
    fetchUser: id=> dispatch(fetchUser(id))
});
  
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserDecorator);
  